import { useQuery } from '@tanstack/react-query';
import { fetchTrendingEvents } from '../../api/events';
import { queryKeys } from '../../lib/query/queryKeys';
import { STALE } from '../../lib/query/staleTimes';
import { filterDisplayOpenEvents } from '../../utils/eventFeedModel';

export function useTrendingEvents({ userId, authReady, enabled = true }) {
  return useQuery({
    queryKey: queryKeys.events.trending(userId),
    queryFn: () => fetchTrendingEvents(userId),
    enabled: authReady && enabled,
    staleTime: STALE.semiStatic,
    // The list is kept 20 minutes; a show that ends in that time leaves on the next render, not the next fetch.
    select: filterDisplayOpenEvents,
  });
}
